var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvieAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Evie Gradient Avatar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Star-inspired avatar badge with the Evie gradient.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sparkGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B45CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#8A74FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#45D7FF"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "gradientTransform",
    type: "rotate",
    values: "0 0.5 0.5;360 0.5 0.5",
    dur: "28s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sparkleHighlight",
    cx: 0.68,
    cy: 0.28,
    r: 0.52
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF",
    stopOpacity: 0.85
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-opacity",
    values: "0.25;0.85;0.25",
    dur: "3.2s",
    repeatCount: "indefinite",
    begin: "0.6s"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "evieAvatarShape",
    d: "m9.1406 48.762c-1.0781 0.46484-1.0781 2.0117 0 2.4766l12.207 5.2891c5.2461 2.2734 9.2773 6.707 11.082 12.184l5.8906 17.867c0.40234 1.2305 2.1211 1.2305 2.5273 0l5.8867-17.867c1.8047-5.4766 5.8398-9.9102 11.086-12.184l12.207-5.2891c1.0742-0.46484 1.0742-2.0117 0-2.4766l-12.207-5.2891c-5.2461-2.2734-9.2812-6.707-11.086-12.184l-5.8867-17.867c-0.40625-1.2305-2.125-1.2305-2.5273 0l-5.8906 17.867c-1.8047 5.4766-5.8359 9.9102-11.082 12.184zm49.406-26.188c-0.28516 0.12891-0.28516 0.55859 0 0.6875l3.2578 1.4688c1.3984 0.63281 2.4727 1.8633 2.9531 3.3828l1.5703 4.9648c0.10938 0.33984 0.56641 0.33984 0.67578 0l1.5703-4.9648c0.48047-1.5195 1.5547-2.75 2.957-3.3828l3.2539-1.4688c0.28516-0.12891 0.28516-0.55859 0-0.6875l-3.2539-1.4727c-1.4023-0.62891-2.4766-1.8633-2.957-3.3828l-1.5703-4.9609c-0.10938-0.34375-0.56641-0.34375-0.67578 0l-1.5703 4.9609c-0.48047 1.5195-1.5547 2.7539-2.9531 3.3828zm8.3906 48.672c-0.35938-0.15625-0.35938-0.66797 0-0.82422l4.0664-1.7656c1.75-0.75781 3.0938-2.2344 3.6953-4.0586l1.9609-5.957c0.13672-0.41016 0.71094-0.41016 0.84375 0l1.9648 5.957c0.60156 1.8242 1.9453 3.3008 3.6914 4.0586l4.0703 1.7656c0.35938 0.15625 0.35938 0.66797 0 0.82422l-4.0703 1.7617c-1.7461 0.75781-3.0898 2.2383-3.6914 4.0625l-1.9648 5.957c-0.13281 0.41016-0.70703 0.41016-0.84375 0l-1.9609-5.957c-0.60156-1.8242-1.9453-3.3047-3.6953-4.0625zm12.391-29.855c-0.21484 0.10547-0.21484 0.44922 0 0.55078l2.4414 1.1758c1.0469 0.50391 1.8555 1.4922 2.2148 2.707l1.1797 3.9727c0.082032 0.26953 0.42578 0.26953 0.50391 0l1.1797-3.9727c0.35938-1.2148 1.168-2.2031 2.2148-2.707l2.4414-1.1758c0.21484-0.10156 0.21484-0.44531 0-0.55078l-2.4414-1.1758c-1.0469-0.50391-1.8555-1.4883-2.2148-2.707l-1.1797-3.9688c-0.078125-0.27344-0.42188-0.27344-0.50391 0l-1.1797 3.9688c-0.35938 1.2188-1.168 2.2031-2.2148 2.707z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "avatarClip"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#evieAvatarShape"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 24,
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.666 0) scale(0.533) translate(5 10)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "avatar-shape"
  }, /*#__PURE__*/React.createElement("g", {
    className: "core"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#evieAvatarShape",
    fill: "url(#sparkGradient)"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.92;1;0.92",
    dur: "3.4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    className: "outline-glimmer",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("use", {
    href: "#evieAvatarShape",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.15;0.65;0.15",
    dur: "2.6s",
    repeatCount: "indefinite",
    begin: "0.4s"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "sheen",
    clipPath: "url(#avatarClip)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("rect", {
    x: -90,
    y: -10,
    width: 220,
    height: 160,
    fill: "url(#sparkleHighlight)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    values: "-90;10;90;-90",
    dur: "5.4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.75;0.2",
    dur: "5.4s",
    repeatCount: "indefinite"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvieAvatar);
export default __webpack_public_path__ + "static/media/evie-avatar.63441bfddb4db91c9684a406a788419a.svg";
export { ForwardRef as ReactComponent };